import React from 'react';

export const PublicReportDialog = () => {
  return <div></div>;
};
